var project = {
    per_page: 4,
    updateNbToLoad: function() {
        var _this = this;
        _this.per_page = 4;
        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)")) {
            _this.per_page = 2;
        }
        else if ( Modernizr.mq("screen and (max-width:"+bp_desktop+"px)")) {
            _this.per_page = 3;
        }
        else {
            _this.per_page = 4;
        }

        // if ( Modernizr.mq("screen and (max-width:"+bp_phone+"px)")) {
        //     _this.per_page = 2;
        // }
    },
    updateMarkup: function(e) {
        // if in window resize event, "this" is given as param
        var _this = e == null ? this : e.data.obj;

        var is_already_tablet = false;
        var is_already_desktop = false;
        var is_already_default = false;


        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)")) {
            if ( _this.per_page == 2 ) { is_already_tablet = true; }
        }
        else if ( Modernizr.mq("screen and (max-width:"+bp_desktop+"px)"))  {
            if ( _this.per_page == 3 ) { is_already_desktop = true; }
        } else if ( _this.per_page == 4 ) {
           is_already_default = true;
        }
        if ( is_already_tablet || is_already_desktop || is_already_default ) {
            var needToUpdate = false;
        } else {
            var needToUpdate = true;
        }

        // Update content only if needed
        if ( needToUpdate == true ) {
            nfIsLoading = false;
            nfMoreData = true;
            nfPage = 0;
            $( ".spaces-load-more" ).parent('.load-more-btn-container').addClass('loading');
            $(".spaces-listing").html('');
            $( ".spaces-load-more" ).trigger( "click" );
        }
    },
    init: function () {
        var _this = this;
        nfPage = 0;
        nfIsLoading = false;
        nfMoreData = true;
//        $(document).ready(function(){
//            $( ".spaces-load-more" ).trigger( "click" );
//        });

        // update number of card showing
        $(window).smartresize(function(e){
            _this.updateMarkup();
        });
        
        $(document).off('click', '.spaces-load-more');
        $(document).on('click', '.spaces-load-more', function() {
        // $(document).off('click').on('click', '.spaces-load-more', function() {
            if(nfIsLoading || !nfMoreData) {
                return;
            }
            nfIsLoading = true;

            var btn = $(this);

            btn.addClass('loading');
            _this.updateNbToLoad();
            

            // $(".news-listing").append("<div class='spinner-load-more'><div class='spinner'></div><p class='mb0'>Load more</p></div>");
            var _project_id = $("#current_project_id").val();
            var fdata = 'action=load_more_products&page=' + nfPage +'&loadmore=yes&project_id='+_project_id+'&per_page='+_this.per_page;

            var deferred_request = $.ajax({
                method: "POST",
                url: admin_ajax_url,
                data: fdata,
                datatype: "JSON"
            });

            deferred_request.done(function( data ) {
                data = $.parseJSON(data);

                if (data.count + data.offset >= data.total_count ) {
                    btn.addClass('is-hidden');
                } else {
                    btn.removeClass('is-hidden');
                }

                $(".spaces-listing").append(data.content);
                $( ".spaces-load-more" ).parent('.load-more-btn-container').removeClass('loading');
                if(data.more_data === 1) {
                    //$(".news-listing").append(data.content);
                    nfMoreData = true;
                    nfPage = nfPage + 1;
                    btn.removeClass('is-hidden');
                    // btn.removeClass('is-hidden');
                    // $('.insights-load-more').show();
                } else {
                    nfMoreData = false;
                    btn.addClass('is-hidden');
                    // btn.addClass('is-hidden');
                    // $('.insights-load-more').hide();
                }

                lazyload.init();
                shortlist.checkIfProductsShortlisted();
                _this.collapse();
                nfIsLoading = false;
                // $(".news-listing .spinner-load-more").remove();
            });

            deferred_request.fail(function( data ) {
                nfIsLoading = false;
                console.log('Failed AJAX Call :( /// Return Data: ' + data);
                // $(".news-listing .spinner-load-more").remove();
            });

            deferred_request.always(function() {
                btn.removeClass('loading');

            });
        });
    },
    collapse: function() {
        //console.log('collapse');
        $(document).on('click', '.space-card .mobile-body', function(e) {
            var $_target =  $(e.currentTarget);
            var $_panelBody = $_target.find(".panel-collapse");
            if($_panelBody){
              $_panelBody.collapse('toggle');
            }
        });
    },
    destroy: function () {
    }
};